export default __webpack_public_path__ + "static/media/sun.26fb5ace.svg";